var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeroChina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#F3F1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2359 23.7718C55.2359 23.8645 55.1729 23.9348 55.0814 23.9512L45.0629 25.3631C45.6105 27.14 46.2301 29.8531 45.4935 33.0658C44.8739 35.761 43.3691 37.994 41.1398 39.5241C38.795 41.1304 36.2671 41.5836 34.4908 41.5178L22.9781 53H16.7627L29.3961 40.402C27.4413 39.6198 25.5525 38.4487 23.9128 36.9665C16.1881 29.9997 16.2091 20.0805 17.6463 13L36.0346 29.1846V34.8531L21.3144 21.8977C21.4614 25.2555 22.5386 29.9982 26.7647 33.8181C29.5791 36.3593 33.1436 37.6545 36.0706 37.1879C38.7485 36.7646 40.7648 34.8456 41.3318 32.1819C41.9604 29.2264 41.0363 26.5567 38.5969 24.4702L41.4144 21.6644L55.0829 23.5953C55.1744 23.6072 55.2374 23.6805 55.2374 23.7718H55.2359Z",
    fill: "#121D25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10603_7887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1Z",
    fill: "#D80027",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47266 6.08594L6.33594 8.74219H9.12891L6.87109 10.3867L7.73437 13.043L5.47266 11.4023L3.21094 13.043L4.07812 10.3867L1.81641 8.74219H4.60937L5.47266 6.08594Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8555 15.4883L11.1953 14.6758L10.2188 15.0547L10.7852 14.1758L10.125 13.3594L11.1367 13.6289L11.707 12.75L11.7617 13.7969L12.7773 14.0664L11.7969 14.4414L11.8555 15.4883Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.168 13.1055L13.4805 12.1055L12.625 11.5L13.6719 11.4844L13.9805 10.4844L14.3203 11.4766L15.3672 11.4648L14.5273 12.0898L14.8633 13.082L14.0078 12.4766L13.168 13.1055Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9375 7.33984L14.4766 8.28125L15.2266 9.01172L14.1914 8.86328L13.7305 9.80078L13.5508 8.76953L12.5117 8.62109L13.4414 8.13281L13.2617 7.09766L14.0117 7.82812L14.9375 7.33984Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8828 4.48828L11.8047 5.53125L12.7773 5.92578L11.7578 6.17578L11.6836 7.22266L11.1328 6.33203L10.1133 6.58203L10.7891 5.78125L10.2344 4.89453L11.207 5.28906L11.8828 4.48828Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10603_7887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeroChina);
export default __webpack_public_path__ + "static/media/weroChina.3b2aae8252c68b06295c2e957f643478.svg";
export { ForwardRef as ReactComponent };